<script lang="ts" generics="T">
  import InputLabel from './InputLabel.svelte';

  type Option = {
    value: T;
    label: string;
  };

  type Props = {
    label: string;
    name: string;
    options: Option[];
    value: T[];
    onchange: (value: T[]) => void;
  };

  const { name, label, options, value, onchange }: Props = $props();

  const handleChange = (optionValue: T) => {
    const newValue = value.includes(optionValue)
      ? value.filter((v) => v !== optionValue)
      : [...value, optionValue];

    onchange(newValue);
  }
</script>

<div class="multi-checkbox-input">
  <InputLabel>{label}</InputLabel>
  <div class="flex flex-col gap-1">
    {#each options as option}
      <label class="flex items-start gap-2 cursor-pointer">
        <input
          name={name}
          class="peer hidden"
          type="checkbox"
          value={option.value}
          checked={value.includes(option.value)}
          onchange={() => handleChange(option.value)}
        />
        <div class="shrink-0 w-4 aspect-square border-2 border-pink text-pink relative peer-checked:[&_svg]:block">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linejoin="round" class="hidden absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3.5 aspect-square"><path d="M20 6 9 17l-5-5"/></svg>
        </div>
        <span class="text-white text-[.8rem] py-[.04rem]">{option.label}</span>
      </label>
    {/each}
  </div>
</div>